import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  fetchCustomShapes,
  setCustomShapes,
  setSelectedGroupIsLoading,
  setMapIsLoading,
} from '../../../store/actions';
import { getWithToken } from '../../../api/network';

export function* getAssumptionsCustomShapesSaga() {
  yield takeEvery(fetchCustomShapes, function* ({ payload }) {
    try {
      yield put(setSelectedGroupIsLoading(true));
      yield put(setMapIsLoading(true, 'SHAPES', 'Loading Custom Shapes...'));

      const url = `/api/assumptions/shapes/coordinates?groupId=${payload.groupId}`;
      const res = yield getWithToken(url);
      const data = yield res.json();

      yield put(setCustomShapes(data));
      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(false, 'SHAPES'));
    } catch (error) {
      yield put(appNotify(`Failed to get shapes: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(false, 'SHAPES'));
    }
  });
}
